/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：1070
 */

var r = require(/* 1102 */"./1102")
var i = require(/* 1551 */"./1551")
module.exports = function (e, t) {
  return !t || "object" !== r(t) && "function" !== typeof t ? i(e) : t
}
